export default {
  init() {
    initBookablesList();
    initSideCal();

    function initSideCal() {

      $('#eventscalendar .calendar-1').css('opacity', 1);
      $('#calfilter').addClass('d-none');

      $('#eventscalendar .selectable').click(function(e) {
        e.preventDefault();
        var clicked = $(this).data('date');
        console.log('sidecal clicked ' + clicked);
        $('#eventscalendar button.selectDate').removeClass('selected');
        // $('#bookingsList > h2').hide();
        $('#calfilterdate').html($(this).data('date-human'));
        $('#eventscalendar button[data-date="' + clicked + '"]').addClass('selected');
        var passed = 0;


        $('.bookable').each(function (i, el) {
          if ($(el).data('date').indexOf(clicked) >= 0) {
            $(this).show();
            passed++;
          } else {
            $(this).hide();
          }

        });

        var counttastings = 0,
            // countbistros = 0,
            countevents = 0;

        $('#bookabletastings .bookable').each(function (i, el) {
          if ($(el).is(':visible'))
            counttastings++;
        });
        // $('#bookablebistros .bookable').each(function(i, el){
        //   if( ! $(el).hasClass('d-none') )
        //     countbistros++;
        // });
        $('#bookableevents .bookable').each(function (i, el) {
          if ($(el).is(':visible'))
            countevents++;
        });

        $('#filtersplaintastings').html(counttastings);
        $('#filtersplainevents').html(countevents);

        if (counttastings == 0)
          $('.re-tastings').hide();
        else
          $('.re-tastings').show();
        if (countevents == 0)
          $('.re-events').hide();
        else
          $('.re-events').show();

        $('#filtersplaindate').html($(this).data('date-human'));
        $('#filtersplain').removeClass('d-none');
        $('#filtermonth').html('');

        $('#calfiltercount').html( passed );
        $('#calfilter').removeClass('d-none');
      });

      $('#eventscalendar .nextcal').click(function() {
        $('#eventscalendar .calendar-1').css('opacity', 0.5);
        $.ajax('/wp-admin/admin-ajax.php', {
          method: 'post',
          data: {
            'action': 'mbfmovecal',
            'onecal': '1',
            'thiscal': $(this).data('month'),
            'direction': $(this).data('direction'),
          },
          success: function(data) {
            var returned = JSON.parse(data);
            $('#bookingcalendars').html(returned.bookingcals);
            $('#eventscalendar').html(returned.calendar);
            $('#bookingsList').css('opacity', 0.5);
            $.ajax('/wp-admin/admin-ajax.php', {
              method: 'post',
              data: {
                'action': 'mbfmovebookingpage',
                'month': returned.month,
              },
              success: function(data) {
                $('#bookingsList').html(data);
                $('#bookingsList').css('opacity', 1);
                initBookablesList();
                },
            });

            initSideCal();
          },
        });


      });
    }


    function initBookablesList() {

      $('.book-button, .booking-cat').click(function(e){
        e.preventDefault();

        clearBookable();
        loadBookable($(this).data('bookable'), $(this).data('month-a'));
        $('#bookingPopUp').modal('show');
      });

      $('#bookingPopUp').on('shown.bs.modal', function(){


        $('.selectDate').click(function(e){
          e.preventDefault();
          $('#popBookDate').val($(this).data('show'));
          $('#popBookDate').data('date', $(this).data('date'));
          $('#popBookDate').prop('disabled', false);
          $('#popBookDate').trigger('change');
          $('#popBookDate').prop('disabled', true);
        });

        $('#popBookDate').change(loadTimes);
      });
    }


    function clearBookable() {
      $('#popTitle').html('');
      $('#popExcerpt').html('<div class="w-100 d-flex justify-content-center"><img src="/wp-content/themes/13thwinery/resources/assets/images/Rotatingrings.gif" style="width: 100px; height: 100px; margin: 10px auto;" /></div>');
      $('#quantityLabel').html('');
      $('.booking-calendars').hide();
      $('#selections').hide();
      $('#prepayicon').addClass('d-none');
      $('#popTimes').html('');

      // reset which dates are available
      $('.booking-calendars .day.number.selectable').each(function(i, e) {
        $(e).html('<span>' + $(e).data('day') + '</span>');
      });

      console.log('cleared');
    }

    function loadBookable( id, monthA ) {

      $('#bookingPopUp').data('bookable', id);
      $('.booking-modal-body .time-options').hide();

      $.ajax('/wp-admin/admin-ajax.php', {
        method: 'POST',
        data: {
          'action': 'bookable',
          'bookable': id,
          'firstmonth': monthA ? monthA : $('#eventscalendar .calendar-1').data('month'),
        },
        success: function(data) {
          console.log('here 161');
          $('#popType').html(data.bookable.booktype);
          $('#popTitle').html(data.bookable.post_title);
          $('#popExcerpt').html(data.bookable.post_content);
          if(data.bookable.booktype == 'pickup')
            $('#quantityLabel').html('QUANTITY');
          else
            $('#quantityLabel').html('GUESTS');

          // if we are not selling anything / asking to register at all
          if(data.bookable._product_id != 0) {
            $('.booking-modal-body .time-options').show();
          }

          $('#popPartySize').prop('min', data.bookable.party_min ? data.bookable.party_min : 1)
            .val(data.bookable.party_min ? data.bookable.party_min : 1);

          if( data.bookable.party_max )
            $('#popPartySize').prop('max', data.bookable.party_max);


          if( data.bookabledates.length == 0 ) {
            $('.booking-calendars').hide();
            $('#popTimes').html('<p><strong>No Available Dates</strong> for this event.</p>');
          }
          else if( data.bookabledates.length == 1 ){
            $('.booking-calendars').hide();
            $('#popBookDate').data('date', data.bookabledates[0] );
            $('#popBookDate').val(data.bookabledates[0]);
            loadTimes();
          }
          else {
            $('#bookingcalendars').html(data.calendars);
            $('.booking-calendars .nextcal').data('bookable', data.bookable.ID);
            initBookingCalendars(data.bookabledates);

          }

          $('#selections').data('fields', data.fields).html(data.selections);
          if (parseInt(data.fields) == 0)
            $('#selections').hide();
          else
            $('#selections').show();


          if( data.free == 0 && data.bookable._product_id != 0 )
            $('#prepayicon').removeClass('d-none');
          // fixMenuQty();

          if( data.bookable.party_min && data.bookable.party_max ) {
            $('#popPartySize').change( function() {
              var ppsval = parseInt($('#popPartySize').val());
              if (ppsval < $('#popPartySize').prop('min') || ppsval > $('#popPartySize').prop('max')) {
                $('#popPartySize').val($('#popPartySize').prop('min'));
                alert('Party Size has been reset to ' + $('#popPartySize').prop('min') + '.  You can book between ' + $('#popPartySize').prop('min') + ' and ' + $('#popPartySize').prop('max') + ' guests.');
              }
            });
          }

          console.log('here');
          $('#partyMinus').off('click')
              .click(function(e){
                console.log('partyMinus from ' + $('#popPartySize').val());
                e.preventDefault();
                var partySize = $('#popPartySize').val();
                if( parseInt(partySize) - parseInt($('#popPartySize').prop('min')) >= 1 ) {
                  partySize--;
                  $('#popPartySize').val(partySize);
                  // fixMenuQty();
                }
                console.log('... out at ' + $('#popPartySize').val());
              });
          $('#partyPlus').off('click')
              .click(function(e){
                console.log('partyPlus from ' + $('#popPartySize').val());

                e.preventDefault();
                var partySize = $('#popPartySize').val();
                if( parseInt(partySize) < parseInt($('#popPartySize').prop('max')) ) {
                  partySize++;
                  $('#popPartySize').val(partySize);
                  // fixMenuQty();
                }
                console.log('partyPlus from ' + $('#popPartySize').val());

              });

          initcal();
        },
      });



    }

    // function fixMenuQty() {
    //   var html = '';
    //   var i = 0;
    //
    //   console.log($('#bookingPopUp').data('bookable'));
    //
    //
    // }

    function loadTimes() {

      $('#popTimes').html('<div class="w-100 d-flex justify-content-center"><img src="/wp-content/themes/13thwinery/resources/assets/images/Rotatingrings.gif" style="width: 50px; height: 50px; margin: 5px auto;" /></div>');

      $.ajax('/wp-admin/admin-ajax.php', {
        method: 'post',
        data: {
          action: 'booktimes',
          bookable: $('#bookingPopUp').data('bookable'),
          bookdate: $('#popBookDate').data('date'),
        },
        success: function(data){
          var timeshtml = '';
          $.each( data.times, function( index, time ) {
            timeshtml += '                        <button class="red-time-button" data-booktime="' + time.start + '">\n' +
                '                            <div class="time-option">\n' + time.show +
                '                            </div>\n' +
                '                            <div class="time-options-inc">\n' +
                '                                <img src="/wp-content/themes/13thwinery/resources/assets/images/Plus-white.svg" alt="" style="width: 36px; height: 36px;" />\n' +
                '                            </div>\n' +
                '                        </button>\n';
          });

          if( data.times.length == 0 )
            timeshtml = '<p>Sorry, this event is <strong>Sold Out</strong> on this date.</p>';
          else if (data.times == '')
            timeshtml = '<p>See you at 13th!  You do not need to register for this event.</p>';

          $('#popTimes').html(timeshtml);

          $('#popTimes button').click(function(e){
            e.preventDefault();
            var menus = '';

            if( $('#selections').data('fields') ) {

              for (var i = 0; i < $('#selections').data('fields'); i++) {
                menus += $('select[name="selection' + i + '"]').data('prompt') + ': ' + $('select[name="selection' + i + '"]').val() + '\r\n';
              }
            }

            $.ajax('/wp-admin/admin-ajax.php', {
              method: 'post',
              data: {
                action: 'bookit',
                bookable: $('#bookingPopUp').data('bookable'),
                partySize: $('#popPartySize').val(),
                bookdate: $('#popBookDate').data('date'),
                booktime: $(this).data('booktime'),
                menus: menus,
              },
              success: function(){
                window.location.href = '/cart';
              },
            });
          });
        },
      });
    }

    function initcal() {
      console.log('initcal()');
      $('#bookingcalendars .nextcal').click(function (e) {
        e.preventDefault();
        console.log(e.target);
        console.log('handling nextcal');
        $('#popTimes').html('');
        $('#popBookDate').val('');

        $.ajax('/wp-admin/admin-ajax.php', {
          method: 'post',
          data: {
            action: 'mbfmovecal',
            bookable: $(this).data('bookable'),
            thiscal: $(this).data('month'),
            direction: $(this).data('direction'),
          },
          success: function (data) {
            console.log(data);
            $('#bookingcalendars').html(data.calendars);
            initcal();
            initBookingCalendars(data.bookabledates);
          },
        });
      });
    }

    function initBookingCalendars(bookabledates) {
      $('.booking-calendars').show();

      // all listed dates selectable
      $.each(bookabledates, function (i, e) {
        console.log(i + ': ' + e);
        var date = new Date(e);
        $('.selectable[data-date="' + e + '"]')
            .removeClass('other-month')
            .html('<button class="selectDate" data-date="' + e + '">' + date.getDate() + '</button>');
      });

      $('.selectDate').click(function (e) {
        e.preventDefault();
        $('#popBookDate').data('date', $(this).data('date'));
        $('#popBookDate').prop('disabled', false);
        $('#popBookDate').val($(this).parent().data('show')).trigger('change');
        $('#popBookDate').prop('disabled', true);
      });
    }
  },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/booking.js